export class UuidService {
    /* @ngInject */
    constructor($http, egUrlService, $window, $log, $q) {
        this.$http = $http;
        this.egUrlService = egUrlService;
        this.$window = $window;
        this.$log = $log;
        this.$q = $q;
        this.requestSuccessCallback = (response) => {
            return this._requestSuccess(response);
        };
        this.requestErrorCallback = (response) => {
            return this._requestError(response);
        };
    }

    getRandomUuid() {
        var url = this.egUrlService.url('/authentication/uuids/random');
        return this.$http.get(url)
            .then(this.requestSuccessCallback, this.requestErrorCallback);
    }

    _requestSuccess(response) {
        return response.data;
    }

    _requestError(response) {
        return this.$q.reject(response.data);
    }
}